import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { body: String }

  open(event) {
    event.preventDefault()

    if (typeof window.Intercom !== "function") {
      return
    }

    const body = this.bodyValue ? this.bodyValue.replace(/\\n/g, "\n") : ""
    window.Intercom("showNewMessage", body)
  }
}
